import React, { FC } from 'react';
import { format } from 'date-fns';
import TableWithColumnSelectorFixedHeader, { TableType } from '../../core/TableWithColumnSelectorFixedHeader';
import { useQuery } from '@apollo/client';
import { anesthesiologistPatientsAnalyticsQuery } from '../../../graph/dashboard';
import { getMinutes } from './util';
import { AnesthesiologistPatientJourneyTableData } from '../../../types/Analytics';
import { DateRangeType } from '../../../types/utils';

const toTableData = (data: AnesthesiologistPatientJourneyTableData[]): TableType => {
  const baseHeaders = [
    'Date of service',
    'Patient MRN',
    'Patient',
    'OR',
    'Procedure Type',
    'Pre Op',
    'Wheels In, Wheels Out',
    'Patient In To Anesthesia Start',
    'Anesthesia Start To Complete',
    'Recovery',
    'Pre OP to Exit',
    'Admitted',
    'Pre Op In',
    'Pre Op Out',
    'OR In',
    'Anesthesia Start',
    'Anesthesia End',
    'OR Out',
    'Recovery In',
    'Recovery Out',
    'Discharged At',
  ];
  return {
    configHeader: [...baseHeaders],
    headers: [
      {
        id: 'h1',
        columns: [
          'Date of service',
          'Patient MRN',
          'Patient',
          'OR',
          'Procedure Type',
          'Pre Op',
          'Wheels In, Wheels Out',
          'Patient In To Anesthesia Start',
          'Anesthesia Start To Complete',
          'Recovery',
          'Pre OP to Exit',
          'Admitted',
          'Pre Op In',
          'Pre Op Out',
          'OR In',
          'Anesthesia Start',
          'Anesthesia End',
          'OR Out',
          'Recovery In',
          'Recovery Out',
          'Discharged At',
        ],
      },
    ],
    rows: (data || []).map(e => ({
      id: e?.id.toString(),
      columns: [
        e.surgeryTime,
        e.patientProviderId || '',
        e.patient,
        e.operationRoom,
        e.procedureType,
        getMinutes(e.preOpInMinutes),
        getMinutes(e.pipoInMinutes),
        getMinutes(e.patientInToAnesthesiaStartInMinutes),
        getMinutes(e.anesthesiaStartToAnesthesiaCompleteInMinutes),
        getMinutes(e.recoveryInMinutes),
        getMinutes(e.preOpToExitInMinutes),
        e.admittedAt,
        e.preOpIn,
        e.preOpOut,
        e.orIn,
        e.anesthesiaStart,
        e.anesthesiaEnd,
        e.orOut,
        e.recoveryIn,
        e.recoveryOut,
        e.dischargedAt,
      ],
    })),
  };
};

const AnesthesiologistPatientsAnalytics: FC<{
  anesthesiologistId: number;
  anesthesiologistName?: string;
  dateRange: DateRangeType;
  filter: any;
}> = ({ anesthesiologistId, anesthesiologistName, dateRange, filter }) => {
  const { data } = useQuery(anesthesiologistPatientsAnalyticsQuery, {
    variables: {
      anesthesiologistId,
      filter,
    },
  });

  const table: AnesthesiologistPatientJourneyTableData[] = data?.anesthesiologistPatientsAnalytics || [];

  return (
    <>
      <TableWithColumnSelectorFixedHeader
        configName="anesthesiologist-patients-table-config"
        tableId="Anesthesiologist-Patients-table"
        tableName={`For anesthesiologist ${anesthesiologistName || ''}`}
        excelFileName={`Anesthesiologist-Patient-Journey-${format(dateRange.from, 'MM/DD/YYYY')}-${format(dateRange.to, 'MM/DD/YYYY')}`}
        {...toTableData(table)}
      />
    </>
  );
};

export default AnesthesiologistPatientsAnalytics;
